exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "infos-product .errorMessage{display:block!important}infos-product .buttonList{margin-left:-1%!important}infos-product .tryAndBuyMessage{color:#c42720}infos-product .dimmer{position:relative}infos-product .spinner{height:20px;width:20px;border-width:4px;left:unset;right:-22px;top:-14px;margin-top:unset;margin-left:unset}infos-product .voucherButtons{vertical-align:unset;float:left;margin-top:0!important}infos-product .voucherButtons .cancel{margin:1em auto}infos-product .voucherButtons button{margin-top:0!important}@media (min-width:350px) and (max-width:390px){.voucher{float:left}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/manage-purchase/my-purchase/infos-product/infos-product.styl
// module id = 917
// module chunks = 0